/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type MainComponentQueryRendererQueryVariables = {
    rightsFilter?: Array<string | null> | null | undefined;
};
export type MainComponentQueryRendererQueryResponse = {
    readonly viewer: {
        readonly rights: ReadonlyArray<{
            readonly right: string | null;
        } | null> | null;
    } | null;
};
export type MainComponentQueryRendererQuery = {
    readonly response: MainComponentQueryRendererQueryResponse;
    readonly variables: MainComponentQueryRendererQueryVariables;
};



/*
query MainComponentQueryRendererQuery(
  $rightsFilter: [String]
) {
  viewer {
    rights(filter: $rightsFilter) {
      right
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rightsFilter"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "rightsFilter"
          }
        ],
        "concreteType": "Right",
        "kind": "LinkedField",
        "name": "rights",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "right",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MainComponentQueryRendererQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MainComponentQueryRendererQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6817c645535dc61f844668160f9d2abc",
    "id": null,
    "metadata": {},
    "name": "MainComponentQueryRendererQuery",
    "operationKind": "query",
    "text": "query MainComponentQueryRendererQuery(\n  $rightsFilter: [String]\n) {\n  viewer {\n    rights(filter: $rightsFilter) {\n      right\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '9943d5206c4f8b8f9dafb96d3bc6235c';
export default node;
